import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useShopifyApi from '../hooks/useShopifyApi';
import WarningCircle from '../assets/img/warning-circle.svg';

// eslint-disable-next-line no-shadow
function SomethingWentWrong({ url }) {
  const store = useSelector(state => ({
    shopify: state.technical?.shopify,
    checkoutLookupData: state.personal?.checkoutLookupData,
    isInstoreVccFlow: state.technical?.instoreVccFlow?.isInstoreVccFlow,
  }));
  const { request, response } = useShopifyApi();

  useEffect(() => {
    // The reject endpoint is Shopify-specific; the in-store VCC flow has no transaction to reject.
    if (store.isInstoreVccFlow) {
      return;
    }
    const rejectRequest = async () => {
      await request.rejectRequest({ transaction_id: store.shopify?.transactionId, reject_reason: 'PROCESSING_ERROR' });
      await response?.json();
    };
    rejectRequest();
  }, []);

  const goBackToRetailor = () => {
    window.location.href = url;
  };

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        <div className="k-error-image-wrapper">
          <img width="150px" height="150px" className="error-icon" src={WarningCircle} alt="" />
        </div>
        <h1 className="congratulation-header">Something went wrong</h1>
        <p className="k-not-approved-text">Unfortunately, something unexpected happened.</p>
        <p className="k-not-approved-text">Click below to try again.</p>
        <div className="k-submit k-error-button k-not-approved-button">
          <button type="button" onClick={goBackToRetailor}>
            <strong>Back To Retailer</strong>
          </button>
        </div>
      </section>
    </div>
  );
}

export default SomethingWentWrong;
